import React from 'react';
import PropTypes, { any } from 'prop-types';

const CheckboxFilter = (props) => {
    const { options = [], filterInputs, filterInputName, onChange, isArray, 'data-testid': dataTestId } = props;
    const createCheckbox = option => {
        const { label, value } = option;
        return (
            <div className="col-12" key={value}>
                <input
                    type="checkbox"
                    name={value}
                    id={value}
                    className="standalone-checkbox"
                    checked={isArray ? filterInputs[filterInputName]?.includes(value) : filterInputs[filterInputName][value]}
                    onChange={() => onChange(value)}
                    data-testid={dataTestId && `${dataTestId}.checkbox-${value}`}
                />
                <label htmlFor={value} data-testid={dataTestId && `${dataTestId}.label-${value}`}><span />{label}</label>
            </div>
        );
    };

    return (
        <div className="row" data-testid={dataTestId}>
            {options.map(option => createCheckbox(option))}
        </div>
    );
};

CheckboxFilter.propTypes = {
    isArray: PropTypes.bool,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterInputName: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(any).isRequired,
    'data-testid': PropTypes.string,
};

CheckboxFilter.defaultProps = {
    isArray: false,
    'data-testid': undefined,
};

export default CheckboxFilter;
